import { useState } from 'react';

/**
 * Ant Design Table'ın onChange(pagination, filters, sorter) callback'inden
 * gelen sorter bilgisini backend'e gönderilecek sort_by/sort_direction'a çevirir.
 * sortField/sortOrder de kolonlarda `sortOrder` prop'u için geri döner ki
 * seçili sıralama ok işareti UI'da görünsün.
 */
const useServerSort = () => {
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null); // antd: 'ascend' | 'descend' | null

  const applySorter = (sorter) => {
    // dataIndex'i olmayan kolonlarda (ör. computed "Ad Soyad") antd sorter.field'ı
    // boş bırakıyor, columnKey her zaman column'daki `key` prop'undan geliyor.
    const field = sorter?.order ? (sorter.columnKey || sorter.field) : null;
    const order = sorter?.order || null;
    setSortField(field);
    setSortOrder(order);
    return {
      sortField: field,
      sortDirection: order ? (order === 'descend' ? 'desc' : 'asc') : null,
    };
  };

  return { sortField, sortOrder, applySorter };
};

export default useServerSort;
